import { render, staticRenderFns } from "./SavedResponseGroup.vue?vue&type=template&id=23180030&scoped=true"
import script from "./SavedResponseGroup.vue?vue&type=script&lang=ts"
export * from "./SavedResponseGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23180030",
  null
  
)

export default component.exports